import {useEffect, useRef, useState, type RefObject} from 'react'

type HandledNewChatPreset = {
  id: string
  applied: boolean
}

export function useNewChatPreset({
  presetId,
  canApply,
  isApplied,
  apply,
  textAreaRef,
}: {
  presetId?: string
  canApply: boolean
  isApplied: boolean
  apply: () => void
  textAreaRef: RefObject<HTMLTextAreaElement | null>
}) {
  const [handledPreset, setHandledPreset] = useState<HandledNewChatPreset>()
  const lastFocusedPresetRef = useRef<string | undefined>(undefined)

  if (presetId && presetId !== handledPreset?.id) {
    setHandledPreset({id: presetId, applied: canApply})
    if (canApply) apply()
  }

  useEffect(() => {
    if (!handledPreset?.applied || !isApplied || lastFocusedPresetRef.current === handledPreset.id) {
      return
    }

    lastFocusedPresetRef.current = handledPreset.id
    textAreaRef.current?.focus()
  }, [handledPreset, isApplied, textAreaRef])
}
